<template>
    <div class="w-full">
        <LazyBaseNavbar />
        <div class="max-w-xl mx-auto  my-5 text-center">
            <div class="text-center max-w-xl my-5 flex justify-center" v-if="error.statusCode == '404'">
                <div class="block grow text-left mt-10">
                    <h1 class="text-xl">{{$t('Sayfa Bulunamadı')}}</h1>
                     <a href="/">{{('Anasayfa')}}</a><br />
                     <a :href="getPath('/tour/umre-turlari')">{{$t('Umre Turları')}}</a><br />
                </div><div class="mb-10 text-center">
                    <img src="/assets/img/not_found404.webp" alt="404 not found" class="text-center"  style="width: 320px; height: 320px;" />
                   
                </div>
            </div>  
            <div class="text-center" v-else>  
                <h3>{{('Bir hata oluştu')}}</h3>
                <button @click="handleError">
                  {{('Clear errors')}}
                </button>

                {{error?.statusCode}} {{ error?.message }}
            </div>
        </div> 
      <LazyBaseFooter2 />
    </div>
</template>
<script setup>
    const { getPath } = useCommon();

    const props = defineProps({
      error: Object
    })
    const handleError = () => clearError({ redirect: '/' });
</script>
